module.exports = {
  common: {
    instagramLink: "https://www.instagram.com/hkwellcome/",
    facebookLink: "https://www.facebook.com/wellcome.supermarket",
    youtubeLink: "https://www.youtube.com/user/Wellcomesupermarket",
    importantSecurityAlert: "Important Security Alert:",
    BewareOfPhishingWebsites: "Beware of phishing websites masquerading as Wellcome",
    importantSecurityLink: "https://www.wellcome.com.hk/d/vSObQHEF8NAhB5P.html"
    // importantSecurityLink: "https://uatsuperweb.rta-os.com/wellcome/d/PrbvVgHXhn.html"
  },
  footer: {
    aboutShop: "About Wellcome",
    followUs: "Follow Wellcome on",
    coptyRight: "© 2024 Wellcome / Market Place. The Dairy Farm Company Limited. All rights reserved.",
    ourStory: "Our Story",
    ourStoryLink: "/en/about-wellcome",
    corporateResponsibility: "Corporate Responsibility",
    corporateResponsibilityLink: "/en/green-initiatives-list",
    storeLocatorLink: "/en/store_locator",
    careersLink: "/en/join-us",
    corporatePromotionsLink: "/en/yuu-rewards-club",
    foodPermitsLink: "/dl/All_Wellcome.com.hk_2024(combined).pdf",
    foodPermitsName: "Wellcome license.pdf",
    tel: "+852 3001 1299",
    emailLink: "contactus@yuurewardsclub.com.hk",
    privacyPolicyLink: "https://www.yuurewards.com/en/privacy-policy",
    termsAndConditionsLink: "https://www.wellcome.com.hk/en/d/hcDR1FBqZ4.html",
    wellcomeWhatsAppTermsAndConditions: "Wellcome WhatsApp Terms and Conditions",
    wellcomeWhatsAppTermsAndConditionsLink: "/en/wellcome-whatsapp-terms-and-conditions",
    contactUsLink: "https://www.yuurewards.com/en/faq?categoryKey=Wellcome.com.hk",
    appStoreLink: "https://apps.apple.com/tr/app/wellcome-online-shop/id6473398628",
    goolePlayLink: "https://play.google.com/store/apps/details?id=com.rtahk.wellcome&hl=en&gl=US",
    emailBulkorderLink: "Business@Wellcome.com.hk",
    b2bBulkOrdersEnquires: "B2B & Bulk Order Enquires"
  },
  page: {
    siteName: "Wellcome",
    siteUrl: "https://www.wellcome.com.hk",
    // 埋点统一名称 Wellcome Online Store，原名称Wellcome Online Shop
    title: "Wellcome Online Store",
    description:
      "Explore a wide range of fresh produce, rice, oil, beverages, beers, wines, spirits, personal care items and groceries at the Wellcome e-Store. Enjoy great savings on case deals, 24-hour delivery and free shipping over $500! Shop now!"
  },
  pageTitle: {
    cart: "My Cart | Wellcome Online Store",
    checkout: "Secure Checkout | Wellcome Online Store",
    cards: "My Cards | Wellcome Online Store",
    coupons: "My Coupons | Wellcome Online Store",
    order_list: "My Orders | Wellcome Online Store",
    order_details: "Order Details | Wellcome Online Store",
    cashier: "Checkout Cashier | Wellcome Online Store",
    payment: "Payment Successful | Wellcome Online Store",
    categoryName: "{name} | Wellcome Online Store",
    storeLocator: "Store Locator | Wellcome Online Store"
  },
  header: {
    feedbackLink: "https://yuu.qualtrics.com/jfe/form/SV_8pm7dSq3GuAuLFc",
    customerCareLink: "https://www.yuurewards.com/en/faq?categoryKey=Wellcome.com.hk"
  }
}
